import { Controller } from "@hotwired/stimulus"

Function::property = (prop, desc) ->
  Object.defineProperty @prototype, prop, desc

export default class extends Controller

  connect: ->
    @onStartListener = @onStart.bind(@)
    @element.addEventListener("graphic:start", @onStartListener)

    @onResetListener = @onReset.bind(@)
    @element.addEventListener("graphic:reset", @onResetListener)

  disconnect: ->
    @reset()

    @element.removeEventListener("graphic:start", @onStartListener)
    @element.removeEventListener("graphic:reset", @onResetListener)

  onStart: (event) ->
    event.stopImmediatePropagation()
    @start(event.detail)

  onCompleted: (event) ->
    return if event.currentTarget.isEqualNode(@element)
    return if @isCompleted

  onReset: (event) ->
    event.stopImmediatePropagation()
    @reset()

  start: (detail = {}) ->
    # console.log "\"#{@identifier}\" starting"
    @isCompleted = false
    @transitionPlayAttribute = true

  completed: ->
    @element.dispatchEvent(@completedEvent)
    @isCompleted = true
    # console.log "\"#{@identifier}\" completed"


  reset: ->
    @transitionPlayAttribute = false

  onAnimationEnd: (event) ->
    event.stopImmediatePropagation()
    @completed()


  @property "completedEvent",
    get: -> new CustomEvent("graphic:completed", bubbles: true)

  @property "transitionPlayAttribute",
    set: (bool) -> @element.toggleAttribute("data-transition-play", bool)
